"use client";

import { cn } from "@/lib/utils";
import { Accordion, AccordionItem, type Selection } from "@nextui-org/react";
import { MinusIcon, PlusIcon } from "lucide-react";
import { useState } from "react";

export interface IFAQContent {
  key: string,
  title: string,
  content: string,
}

function FrequenltyQuestionSection(props: {
  title: string,
  content: IFAQContent[],
  mode?: "dark" | "light",
}) {
  const [selectedKeys, setSelectedKeys] = useState<Selection>();

  return (
    <section className={cn("w-screen flex items-center justify-center px-[24px]",
      props.mode === "dark" ? "text-white" : ""
    )}>
      <div className=" w-full max-w-[730px] flex flex-col items-start md:items-center justify-center space-y-[20px] lg:space-y-[46px]" >
        <h2 className="h3 md:text-center leading-none max-w-[300px] md:max-w-none ">
          {props.title}
        </h2>
        <Accordion
          selectedKeys={selectedKeys}
          onSelectionChange={setSelectedKeys}
          className="px-0"
        >
          {
            props.content.map((item,) => (
              <AccordionItem
                key={item.key}
                aria-label={item.title}
                title={item.title}
                classNames={{
                  title: [
                    props.mode === "dark" ? "!text-white" : "!text-black",
                    "text-[24px] font-degular-display-semibold !py-0 "
                  ],
                  content: props.mode === "dark" ? "!text-white" : "!text-black",
                }}
                indicator={({ isOpen }) =>
                  isOpen ? (
                    <MinusIcon
                      width={16}
                      height={16}
                      className={cn(
                        "rotate-90",
                        props.mode === "dark" ? "text-white" : "text-black"
                      )}
                    />
                  ) : (
                    <PlusIcon
                      width={16}
                      height={16}
                      className={cn(
                        props.mode === "dark" ? "text-white" : "text-black"
                      )}
                    />
                  )
                }
              >
                {item.content}
              </AccordionItem>
            ))
          }
        </Accordion>
        {/* <PlusIcon
          width={16}
          height={16}
        />
        <MinusIcon
          width={16}
          height={16}
          className=" rotate-90"
        /> */}
      </div>
    </section>
  );
}

export default FrequenltyQuestionSection;
